module.exports = __webpack_public_path__ + "img/facebook.1d9982aa.jpg";